import type { CardProjection } from "./friendship-card-v1";
export const PRECISE_HINT_VERSION = "friendship-precise-hint@1.0.0";
export const PRECISE_HINT = "这段文字可能写到了具体时间或集合地点，可以改成宽时段和城市，把具体安排留到群里说；是否修改由你决定。";
export const MULTI_CARD_HINT = "多张卡和自由文字里的时间、地区与重复规律，合在一起可能让人推知行踪。发布前，可以把这些内容放在一起检查。";
const hour = "(?:2[0-4]|1?[0-9]|二十四|二十三|二十二|二十一|二十|十[一二三四五六七八九]?|[零一二两三四五六七八九])";
const month = "(?:1[0-2]|0?[1-9]|十二|十一|十|[一二三四五六七八九])";
const day = "(?:3[01]|[12][0-9]|0?[1-9]|三十一|三十|二十[一二三四五六七八九]?|十[一二三四五六七八九]?|[一二三四五六七八九])";
const number = "[0-9零一二两三四五六七八九十百千]+";
const rules = [
    new RegExp(`(?<![0-9零一二两三四五六七八九十])${hour}\\s*[点時时](?:整|半|一刻|三刻|\\s*[0-5]?[0-9]\\s*分)?`, "gu"),
    /(?<!\d)(?:2[0-3]|1?[0-9])\s*:\s*[0-5][0-9](?::[0-5][0-9])?(?!\d)/gu,
    new RegExp(`(?<![0-9零一二三四五六七八九十])(?:[0-9]{4}年)?${month}\\s*月\\s*${day}\\s*[日号]`, "gu"),
    /(?<!\d)(?:\d{4}([-./])(?:1[0-2]|0?[1-9])\1(?:3[01]|[12][0-9]|0?[1-9])|(?:1[0-2]|0?[1-9])\/(?:3[01]|[12][0-9]|0?[1-9]))(?!\d)/gu,
    new RegExp(`明天|后天|今天|今晚|今早|(?:每月|本月|下月)\\s*${day}\\s*[日号]`, "gu"),
    /(?:每逢|每|本|这|下)?(?:周|星期|礼拜)[一二三四五六日天]/gu,
    new RegExp(`(?:${number}|[A-Za-z])\\s*(?:号门|号楼|栋|幢|单元|室)|[街路巷]\\s*${number}\\s*号|${number}\\s*[楼层]`, "gu"),
    /东门|西门|南门|北门|正门|后门|[0-9A-Za-z]+(?:号)?(?:出口|出入口)|(?:地铁|车站)[^。！？\n]{0,12}站口/gu,
    /集合点|碰头地点|[在到][^。！？\n]*(?:门口|门前|大堂|前台|入口处)|(?:公园|场馆|咖啡馆|书店|大堂)(?:集合|碰头|见)/gu,
];
/** Matching normalization is deliberately one-to-one, preserving original UTF-16 offsets. */
export function preciseFragments(text: string): string[] {
    const normalized = text.replace(/[！-～]/g, c => String.fromCharCode(c.charCodeAt(0) - 0xfee0)).replace(/\u3000/g, " ");
    const hits: string[] = [];
    for (const rule of rules) {
        rule.lastIndex = 0;
        for (const match of normalized.matchAll(rule))
            hits.push(text.slice(match.index, match.index + match[0].length));
    }
    return [...new Set(hits)];
}
export function preciseHint(projection: CardProjection): {
    show: boolean;
    fragments: {
        questionId: string;
        text: string;
    }[];
} {
    const fragments = projection.items.flatMap(item => item.texts.flatMap(text => preciseFragments(text).map(text => ({ questionId: item.id, text }))));
    return { show: fragments.length > 0, fragments: fragments.filter((x, i, a) => a.findIndex(y => x.questionId === y.questionId && x.text === y.text) === i) };
}
